import { render, staticRenderFns } from "./help.vue?vue&type=template&id=1439dc81"
import script from "./help.vue?vue&type=script&lang=ts"
export * from "./help.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports